export enum NOTIFICATION_BANNER_ID {
  ELECTIONS = 'elections',
}

export type NotificationsFeedDismissedData = { [key in NOTIFICATION_BANNER_ID]?: string }
